import merge from './common/utils/merge';

const { REACT_APP_CS_PROJECT, REACT_APP_CS_REPO, REACT_APP_CS_BRANCH } = process.env;

const defaults = {
  auth: {
    clientId: '6d4167e8-b310-4aaa-b2c9-e4f7a80a2212',
    redirectUri: `${location.protocol}//${location.host}`,
    postLogoutRedirectUri: `${location.protocol}//${location.host}`,
    domain: `http://localhost.test:7001`,
    membersFrontendUri: `https://localhost.test:3000`,
    scope: 'openid email profile',
    responseType: 'code id_token token',
    idTokenKey: 'idToken',
    accessTokenKey: 'accessToken',
  },
  cloudfront: {
    videoDomain: 'https://d2ycorfhx8xf7t.cloudfront.net',
    withCredentials: false,
  },
  sentryEnvironmentTag: 'development',
  validationMessages: {},
};

const environments = {
  development: {},
  qa: {
    auth: {
      domain: `https://${REACT_APP_CS_PROJECT}-${REACT_APP_CS_REPO}-oidc-${REACT_APP_CS_BRANCH}.synsit.es`,
    },
    sentryEnvironmentTag: 'qa',
  },
  staging: {
    auth: {
      clientId: 'f8eb655c-ab30-4bf6-aa0c-e502f48c54b8',
      domain: `https://staging-accounts.tathatagolf.com`,
      membersFrontendUri: `https://staging-members.tathatagolf.com`,
    },
    cloudfront: {
      videoDomain: 'https://staging-cdn.tathatagolf.com',
      withCredentials: true,
    },
    sentryEnvironmentTag: 'staging',
  },
  production: {
    auth: {
      clientId: 'f895ec88-6634-48a1-921b-0fd4b1ab0373',
      domain: `https://account.tathatagolf.com`,
      membersFrontendUri: `https://app.tathatagolf.com`,
    },
    cloudfront: {
      videoDomain: 'https://cdn.tathatagolf.com',
      withCredentials: true,
    },
    sentryEnvironmentTag: 'production',
  },
};

export default merge(defaults, environments[process.env.REACT_APP_ENV]);



// WEBPACK FOOTER //
// ./src/config.js